import {
  isEmailBuilderCompactShellViewport,
  isEmailBuilderMobileViewport,
} from "./emailBuilderViewportLayout";
import { emailBuilderUsesDesktopRightSettingsPanel } from "./canvas/settings/emailBuilderDesktopSettingsPanel";

export interface IEmailBuilderViewportBuckets {
  isMobileLayout: boolean;
  usesBottomSheetChrome: boolean;
  usesCompactSettingsChrome: boolean;
  usesDesktopRightSettingsPanel: boolean;
}

export function emailBuilderViewportBuckets(
  width: number | undefined,
): IEmailBuilderViewportBuckets {
  return {
    isMobileLayout: isEmailBuilderMobileViewport(width),
    usesBottomSheetChrome: isEmailBuilderMobileViewport(width),
    usesCompactSettingsChrome: isEmailBuilderCompactShellViewport(width),
    usesDesktopRightSettingsPanel: emailBuilderUsesDesktopRightSettingsPanel(width),
  };
}
